import { render, staticRenderFns } from "./SelectBoxIt.vue?vue&type=template&id=f32485b2&scoped=true&"
import script from "./SelectBoxIt.vue?vue&type=script&lang=js&"
export * from "./SelectBoxIt.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxIt.vue?vue&type=style&index=0&id=f32485b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32485b2",
  null
  
)

export default component.exports